import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UnitModule } from './helper/anessa-library/anessa-library/projects/unit-library/src/public-api';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { DropdownMenuComponent, TopbarAdminDialogComponent, TopbarConfirmDialogComponent, TopbarSaveAsDialogComponent, TopbarSaveDialogComponent } from './header/topbar/dropdown-menu.component';

import { TabsComponent } from './header/tabs/tabs.component';
import { CommunicationService } from './communication/communication.service';
import { ProjectCommunicationService } from './communication/project-comms.service';
import { LoginGuard } from './auth/login-guard';

import { SharedModule } from './helper/shared.module';

import { HomeComponent } from './home/home.component';
import { AuthService } from './auth/auth.service';
import { TokenInterceptor } from './auth/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResultsModule } from './results/results.module';
import { AccAdminModule } from './acc-admin/acc-admin.module';
import { TopbarProfileDialogComponent } from './header/topbar/topbar-profile-dialog/topbar-profile-dialog.component';
import { DeactivationDialogService } from './helper/can-deactivate/deactivation-dialog.service';
import { CanDeactivateGuard } from './helper/can-deactivate/can-deactivate.guard';
import { ConfiguredToastrService } from './helper/toastr/configured-toastr.service';
import { GlobalErrorHandler } from './error-handler/error-handler';
import { ServerErrorInterceptor } from './error-handler/interceptor/server-error.interceptor';
import { HeaderAppendInterceptor } from './auth/header-append.interceptor';
import { ProjectFinancialService } from './project/financial/project-financial.service';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { adaRxStompConfig } from './socket/ada-rx-stomp.config';
import { AlertsMenuComponent } from './header/topbar/alerts-menu/alerts-menu.component';
import { HelpComponent } from './help/help.component';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { LanguageMenuComponent } from './header/topbar/language-menu/language-menu.component';
import { LoginSignupLanguageButtonsComponent } from './auth/login-signup-language-buttons/login-signup-language-buttons.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PreferencesDialogComponent } from './header/topbar/preferences-dialog/preferences-dialog.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  declarations: [
    AppComponent,
    TopbarComponent,
    TabsComponent,
    HomeComponent,
    DropdownMenuComponent,
    TopbarSaveDialogComponent,
    TopbarConfirmDialogComponent,
    TopbarAdminDialogComponent,
    TopbarProfileDialogComponent,
    TopbarSaveAsDialogComponent,
    AlertsMenuComponent,
    HelpComponent,
    LanguageMenuComponent,
    LoginSignupLanguageButtonsComponent,
    LogoutComponent,
    PreferencesDialogComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    // main imports
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    // forms and directives
    FormsModule,
    ReactiveFormsModule,
    // 3rd party modules
    GuidedTourModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatTooltipModule,
    MatIconModule,
    MatDividerModule,
    MatMenuModule,
    ToastrModule.forRoot({
      newestOnTop: true,
      positionClass: 'toast-bottom-right',
      maxOpened: 5,
    }),
    // our modules
    // ProjectModule,
    SharedModule,
    ResultsModule,
    AccAdminModule,
    UnitModule.forRoot(),
    NgScrollbarModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule], providers: [
    CommunicationService,
    ProjectCommunicationService,
    ProjectFinancialService,
    GuidedTourService,
    DeactivationDialogService,
    ConfiguredToastrService,
    CanDeactivateGuard,
    LoginGuard,
    AuthService,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderAppendInterceptor,
      multi: true
    },
    // socket
    {
      provide: InjectableRxStompConfig,
      useValue: adaRxStompConfig
    },
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
      deps: [InjectableRxStompConfig]
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
